/**
 * ManagerAutoRouter — mobile/tablet use unified CareFlow app; desktop keeps Manager.
 */
import React from "react";
import { isMobile, isTablet } from "../../utils/device";
import ManagerHome from "../../pages/ManagerHome";
import FastBilling from "../../pages/FastBilling";

export default function ManagerAutoRouter() {
  if (isMobile() || isTablet()) return <FastBilling />;
  return <ManagerHome />;
}
